import { gql } from '@apollo/client/core';

export default gql`
  query DataPointRequestXlsxDownload($dataPointRequestIds: [String!]!) {
    getDataPointRequestsEncodedReport(dataPointRequestIds: $dataPointRequestIds)
  }
`;
